import React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import styles from "../OrderhistoryCard/OrderhistoryCard.module.scss";
import EditIcon from "../../Assets/images/edit.svg";
import { PAYMENT_METHODS } from "Helpers/Constants";
import DeleteIcon from "../../Assets/images/delete.svg";

export default function PaymentHistoryCard(props) {
  return (
    <Card className={` ${styles.OrderHistoryCard} ${styles.default}`}>
      <CardContent className={`${styles.content}`}>
        <div className="d-flex justify-content-between">
          <p className={`${styles.CustomerName} d-flex justify-content-between`}>
            <span>{props.data.name_on_card ?? "-"}</span>
            <span>
              {props?.is_delete_bnt && <img
                onClick={(e) => {
                  props.deleteCard(e);
                }}
                src={DeleteIcon}
                style={{
                  position: "absolute",
                  right: "30px",
                  cursor: "pointer", 
                }}
                width="18px"
                height="18px"
                alt="DELETE"
              />
              }
            </span>
          </p>
        </div>
        <div className={`d-flex justify-content-between mt-4`}>
          <p className={`${styles.OrderId}`}>
            xxxx xxxx xxxx {props.data.last_4number ?? "xxxx"}
          </p>
          <p className={`${styles.OrderPrice}`} style={{ fontSize: "18px" }}>
            {props.data.card_type ?? ""}
          </p>
        </div>
      </CardContent>
    </Card>
  );
}
